const menus =  {
	master: {
		title: "Manage Masters",
		icon: "assignment",
		link: "",
		pages: {
			country: {
				title: "Manage Countries",
				link: "/countries",
				icon: "flight"
			},
			state: {
				title: "Manage States",
				link: "/states",
				icon: "train"
			},
			district: {
				title: "Manage Districts",
				link: "/districts",
				icon: "directions_car"
			},
			city: {
				title: "Manage Cities",
				link: "/cities",
				icon: "directions_car"
			},
			panchayath: {
				title: "Manage Panchayaths",
				link: "/panchayaths",
				icon: "motorcycle"
			},
			agent: {
				title: "Manage LTP",
				link: "/agents",
				icon: "directions_walk"
			},
			itemcategory: {
				title: "Manage Item Categories",
				link: "/item-categories",
				icon: "label"
			},
			item: {
				title: "Manage Items",
				link: "/items",
				icon: "local_mall"
			},
			rawmaterial: {
				title: "Manage Raw Materials",
				link: "/raw-materials",
				icon: "local_mall"
			},
			customertype: {
				title: "Manage Customer Types",
				link: "/customer-types",
				icon: "label"
			},
			customer: {
				title: "Manage Customers",
				link: "/customers",
				icon: "face"
			},
			unit: {
				title: "Manage Units",
				link: "/units",
				icon: "label"
			},
			tax: {
				title: "Manage Taxes",
				link: "/taxes",
				icon: "attach_money"
			},
			distributor: {
				title: "Manage Head Offices",
				link: "/suppliers",
				icon: "memory"
			},
			retailer: {
				title: "Manage Branches",
				link: "/branches",
				icon: "business"
			},
			brand: {
				title: "Manage Brands",
				link: "/brands",
				icon: "style"
			},
			extradiscount: {
				title: "Manage Extra Discounts",
				link: "/extra-discounts",
				icon: "card_giftcard"
			},
		}
	},
	module: {
		title: "Manage Modules",
		link: "/modules",
		icon: "code"
	},
	user: {
		title: "Manage Users",
		link: "/users",
		icon: "group"
	},
	role: {
		title: "Manage User Roles",
		link: "/roles",
		icon: "work"
	},
	roleaccess: {
		title: "Manage Role Accesses",
		link: "/module-accesses",
		icon: "lock"
	},
	brandaccess: {
		title: "Manage Brand Accesses",
		link: "/brand-accesses",
		icon: "settings"
	},
	// media: {
	// 	title: "Manage Media",
	// 	link: "/media",
	// 	icon: "collections"
	// },
	invoice: {
		title: "Manage Proforma Invoice",
		link: "/proforma-invoice-list",
		icon: "receipt"
	},
	sale: {
		title: "Manage Sales",
		link: "/sales-list",
		icon: "receipt"
	},
	commission: {
		title: "Manage Commission",
		link: "/commission-list",
		icon: "card_giftcard"
	},
	inventory: {
		title: "Manage Inventory",
		icon: "storage",
		link: "",
		pages: {
			factory: {
				title: "Factory Management",
				link: "/factories",
				icon: "business"
			},
			warehouse: {
				title: "Warehouse Management",
				link: "/warehouses",
				icon: "store"
			},
			purchase: {
				title: "Purchase Management",
				link: "/purchase-list",
				icon: "local_mall"
			},
			production: {
				title: "Production Management",
				link: "/production-list",
				icon: "dns"
			},
			factorydispatch: {
				title: "Stock Dispatch",
				link: "/stock-dispatch-list",
				icon: "local_shipping"
			},
			stockmovement: {
				title: "Stock Movement",
				link: "/stock-movement-list",
				icon: "child_friendly"
			},
		}
	},
	return: {
		title: "Manage Returns",
		icon: "replay",
		link: "",
		pages: {
			purchasereturn: {
				title: "Purchase Return",
				link: "/purchase-return-list",
				icon: "local_mall"
			},
			salereturn: {
				title: "Sales Return",
				link: "/sales-return-list",
				icon: "receipt"
			},
			retailerpurchasereturn: {
				title: "Branch Purchase Return",
				link: "/branch-purchase-return-list",
				icon: "local_mall"
			},
			retailersalereturn: {
				title: "Branch Sales Return",
				link: "/branch-sales-return-list",
				icon: "receipt"
			},
		}
	},
	report: {
		title: "Reports",
		icon: "assignment",
		link: "",
		pages: {
			rawmaterialstockreport: {
				title: "Raw Material Stock",
				link: "/reports/rawmaterial-stock",
				icon: "local_mall"
			},
			factorystockreport: {
				title: "Factory Stock",
				link: "/reports/factory-stock",
				icon: "business"
			},
			warehousestockreport: {
				title: "Warehouse Stock",
				link: "/reports/warehouse-stock",
				icon: "store"
			},
			retailerstockreport: {
				title: "Branch Stock",
				link: "/reports/branch-stock",
				icon: "business"
			},
			salesreport: {
				title: "Sales Report",
				link: "/reports/sales",
				icon: "receipt"
			},
			itemreport: {
				title: "Sales Report - Item Wise",
				link: "/reports/sales-item",
				icon: "local_mall"
			},
			purchasereport: {
				title: "Purchase Report",
				link: "/reports/purchase",
				icon: "local_mall"
			},
			purchaseitemreport: {
				title: "Purchase Item Report",
				link: "/reports/purchase-item",
				icon: "local_mall"
			},
			salesreturnreport: {
				title: "Sales Return Report",
				link: "/reports/sales-return",
				icon: "receipt"
			},
			purchasereturnreport: {
				title: "Purchase Return Report",
				link: "/reports/purchase-return",
				icon: "local_mall"
			},
			commissionreport: {
				title: "Commission Report",
				link: "/reports/commission",
				icon: "local_mall"
			},
			productionreport: {
				title: "Production Report",
				link: "/reports/production",
				icon: "dns"
			},
		}
	},
}

export default menus
